import React, { useEffect, useMemo, useState } from "react";
import { KpiCard } from "../../../../Component/AgentComponents/KpiCard";
import { SectionCard } from "../../../../Component/AgentComponents/SectionCard";


import {
  ShieldCheck,
  FileText,
  IndianRupee,
  Edit3,
  Link2,
  Eye,
} from "lucide-react";
import { formatCurrency } from "../../../../Component/AdminComponents/formatCurrency";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import RegularLoader from "../../../../Component/Loader/RegularLoader";
import Pagination from "../../../../Component/Common/Pagination";
import RefreshButton from "../../../../Component/Common/RefreshButton";
import { BASE_URL, Warrenty_URL } from "../../../../config/api";
import SimpleTable from "../../../../Component/Common/SimpleTable";

import ExpandableCard from "../../../../Component/Common/ExpandableCard";
import toast from "react-hot-toast";
import BlueButton from "../../../../Component/Common/BlueButton";
import KpiSection from "./KpiSection";
import WarrantyTable from "./WarrantyTable";
import ClaimsTable from "./ClaimsTable";
import ClaimConsole from "./ClaimAdminConsole";
import AssignEmployeeModal from "./AssignEmployeeModal";
import ApproveRejectModal from "./ApproveRejectModal";
import { Badge } from "../../../../Component/RetailerMainComponents/Badge";
import { formatDateTime } from "../../../../Component/Common/formatDateTime";


const claims = [
  {
    id: "CLM-5001",
    warrantyId: "WAR-1001",
    retailer: "Shree Mobile Store",
    customer: "Amit Kulkarni",
    device: "Samsung A55",
    raisedBy: "Retailer", // Retailer | Customer
    issue: "Device not powering on",
    status: "Pending", // Pending | Approved | Rejected | In Progress | Settled
    reason: "",
    approvedAmount: 3500,
    payableAmount: 3000,
    payableStatus: "Pending",
    paymentLink: "",
    lastUpdated: "2025-10-15",
  },
  {
    id: "CLM-5002",
    warrantyId: "WAR-0998",
    retailer: "Digital Zone",
    customer: "Demo Customer",
    device: "mPOS Demo",
    raisedBy: "Customer",
    issue: "Screen flickering",
    status: "Rejected",
    reason: "Warranty expired",
    approvedAmount: 0,
    payableAmount: 0,
    payableStatus: "Not Applicable",
    paymentLink: "",
    lastUpdated: "2025-01-07",
  },
  {
    id: "CLM-5003",
    warrantyId: "WAR-1002",
    retailer: "A1 Electronics",
    customer: "Riya Shah",
    device: "Samsung Tab S9",
    raisedBy: "Customer",
    issue: "No sound from speakers",
    status: "Approved",
    reason: "",
    approvedAmount: 2200,
    payableAmount: 2000,
    payableStatus: "Paid",
    paymentLink: "https://pay.goex.example/CLM-5003",
    lastUpdated: "2025-11-10",
  },
];


const todayISO = () => new Date().toISOString().slice(0, 10);

export default function WarrantiesClaimsView({
}) {

  const [warrantiesData, setWarrantiesData] = useState([]);
  const [loadingWarranties, setLoadingWarranties] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [devices, setDevices] = useState([]);
  const [loadingDevices, setLoadingDevices] = useState(true);
  const Navigate = useNavigate();

  const location = useLocation();

  const [claims, setClaims] = useState([]);
  const [claimsLoading, setClaimsLoading] = useState(true);
  const [claimsPage, setClaimsPage] = useState(1);
  const [claimsTotalPages, setClaimsTotalPages] = useState(1);

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assigningClaim, setAssigningClaim] = useState(null);

  const [employees, setEmployees] = useState([]);
  const [loadingEmployees, setLoadingEmployees] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approvingClaim, setApprovingClaim] = useState(null);
  const [extraPayable, setExtraPayable] = useState(0);
  const [extraReason, setExtraReason] = useState("");
  const [activeTab, setActiveTab] = useState("warranties");
// "warranties" | "claims"

  const [approvalFilter, setApprovalFilter] = useState("all");
  // all | active | provisioning | rejected

  const [search, setSearch] = useState("");
const [debouncedSearch, setDebouncedSearch] = useState("");

const [dashboardStats, setDashboardStats] = useState(null);
const [dashboardLoading, setDashboardLoading] = useState(true);



  const approvalParamMap = {
    active: 1,
    provisioning: 0,
    rejected: 2,
  };



  // ⚡ Coming from KPI → showOnlyActive = true
  const showOnlyActive = location.state?.showOnlyActive === true;
  const showOnlyOpen = location.state?.showOnlyOpen === true;
  const authUserString = localStorage.getItem("authUserData");
  const authUser = authUserString ? JSON.parse(authUserString) : null;

  const userRole = Number(authUser?.role);
  const sessionId = authUser?.id;

  const isAdmin = userRole === 1;
  const isCompany = userRole === 2;

  const ALLOWED_CLAIM_CONSOLE_STATUSES = [
  "device_handover_to_company",
  "company_received_device",
  "device_received_by_company",
];

  const isFinalized = (status) =>
    ["Approved", "Rejected", "Settled"].includes(status);

  const canAssignEmployee = (claim) =>
    claim.status === "Approved" && !claim.assigned_employee;

  useEffect(() => {
    if (showApproveModal) {
      setExtraPayable(0);
      setExtraReason("");
    }
  }, [showApproveModal]);


  // const fetchWarranties = async () => {
  //   try {
  //     setLoadingWarranties(true);

  //     // let url = `${BASE_URL}get-customers?page=${currentPage}`;
  //     let url = `${BASE_URL}warranty/get-customers?page=${currentPage}`;

  //     // 🔹 ROLE-BASED PARAMS
  //     if (userRole === 2 || userRole === 4) {
  //       // Company / Distributor
  //       url += `&company_id=${sessionId}`;
  //     }

  //     if (userRole === 5) {
  //       // Retailer
  //       url += `&retailer_id=${sessionId}`;
  //     }

  //     // ROLE 1 (Admin) → no extra params

  //     const res = await fetch(url);
  //     const data = await res.json();

  //     if (data?.data) {
  //       setTotalPages(data.last_page || 1);

  //       const transformed = data.data.flatMap((customer) =>
  //         customer.devices.map((device) => ({
  //           custid: customer.id,
  //           RawID: device.id,
  //           id: `WAR-${device.id.toString().padStart(4, "0")}`,
  //           retailer: customer.name,
  //           retailerCode: `RET-${customer.id}`,
  //           customer: customer.name,
  //           deviceType: device.product_name || "Device",
  //           brand: device.brand_name || "Brand",
  //           model: device.model || "-",
  //           imei: device.imei1 || "-",
  //           type: "Sold",
  //           is_approved:device.is_approved,
  //           soldOn: device.created_at?.slice(0, 10) || "",
  //           expiry: device.expiry_date || "",
  //           plan: device.product_name || "Warranty",
  //           price: device.device_price || 0,
  //         }))
  //       );

  //       setWarrantiesData(transformed);
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch warranties:", error);
  //   } finally {
  //     setLoadingWarranties(false);
  //   }
  // };


  // useEffect(() => {
  //   fetchWarranties();
  // }, [currentPage]); // <-- IMPORTANT

  useEffect(() => {
  if (approvingClaim) {
    setShowApproveModal(true);
  }
}, [approvingClaim]);

useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearch(search.trim());
  }, 500); // ⏳ debounce delay

  return () => clearTimeout(timer);
}, [search]);


  const buildDevicesUrl = ({ role, id, page, approvalFilter, search }) => {
  let url = `${BASE_URL}warranty/get-devices?page=${page}`;

  // 🔹 ROLE BASED
  switch (role) {
    case 2:
      url += `&company_id=${id}`;
      break;
    case 4:
      url += `&agent_id=${id}`;
      break;
    case 5:
      url += `&retailer_id=${id}`;
      break;
    case 6:
      url += `&created_by=${id}`;
      break;
    default:
      break;
  }

  // 🔹 STATUS FILTER
  if (approvalFilter !== "all") {
    url += `&is_approved=${approvalParamMap[approvalFilter]}`;
  }

  // 🔍 SEARCH (only if >= 4 chars)
  if (search && search.length >= 4) {
    url += `&search=${encodeURIComponent(search)}`;
  }

  return url;
};

  const fetchDevices = async () => {
  try {
    setLoadingDevices(true);

    const url = buildDevicesUrl({
      role: userRole,
      id: sessionId,
      page: currentPage,
      approvalFilter,
      search: debouncedSearch, // 👈 important
    });

    const res = await fetch(url);
    const json = await res.json();

    setDevices(json?.data || []);
    setTotalPages(json?.last_page || 1);
  } catch (err) {
    console.error("Failed to fetch devices", err);
    setDevices([]);
  } finally {
    setLoadingDevices(false);
  }
};
      
// Reset page when filters/search change
useEffect(() => {
  setCurrentPage(1);
}, [approvalFilter, debouncedSearch, userRole, sessionId]);

// Fetch whenever page or filters change
useEffect(() => {
  fetchDevices();
}, [currentPage, approvalFilter, debouncedSearch, userRole, sessionId]);


  useEffect(() => {
  if (!assigningClaim) return;

  const companyId = assigningClaim.company_id;

  if (!companyId) {
    console.error("Company ID missing in claim", assigningClaim);
    return;
  }

  fetchEmployees(companyId);
}, [assigningClaim]);


  const fetchEmployees = async (companyId) => {
    try {
      setLoadingEmployees(true);

      const res = await fetch(
        `${BASE_URL}company/employee/all`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization header if required
            // "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({
            company_id: companyId, // ✅ FROM CLAIM ROW
          }),
        }
      );

      const json = await res.json();

      // ✅ IMPORTANT: employees array is nested
      setEmployees(json?.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch employees", err);
      setEmployees([]);
    } finally {
      setLoadingEmployees(false);
    }
  };

  const openAssignModal = (claim) => {
  setAssigningClaim(claim);
  setSelectedEmployee("");
  setShowAssignModal(true);
  fetchEmployees();
};

  const handleAssignEmployee = async () => {
  if (!assigningClaim || !selectedEmployee) {
    toast.error("Missing claim or employee");
    return;
  }

  const toastId = toast.loading("Assigning employee...");

  try {
    const res = await fetch(
      `${BASE_URL}warranty/claim/assign-employee`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          claim_id: assigningClaim.id,       // ✅ numeric backend ID
          employee_id: selectedEmployee,     // ✅ selected employee
        }),
      }
    );

    const json = await res.json();

    if (!json?.status) {
      throw new Error(json?.message || "Assignment failed");
    }

    toast.success("Employee assigned successfully", { id: toastId });

    // 🔄 Refresh claims list
    fetchClaims();

    // 🔒 Close modal
    setShowAssignModal(false);
    setAssigningClaim(null);
    setSelectedEmployee(null);
  } catch (err) {
    toast.error(err.message || "Failed to assign employee", {
      id: toastId,
    });
  }
};

const approvalMap = {
  0: { label: "Provisioning", variant: "warning" },
  1: { label: "Active", variant: "success" },
  2: { label: "Rejected", variant: "danger" },
};


  const deviceRows = useMemo(() => {
  return devices.map((d) => {
    const approval = approvalMap[d.is_approved] || {
      label: "Unknown",
      variant: "gray",
    };

    return {
      raw: d,
      cells: [
        {
          title: d.w_code,
          sub: `Sold: ${formatDateTime(d.created_at)}`,
          // extra: `Exp: ${d.expiry_date}`,
        },
        {
          title: d.customer?.retailer?.business_name || "—",
          sub: d.customer?.name || "—",
        },
        {
          title: `${d.brand_name}`,
          sub: `Model: ${d.model || "-"}`,
          extra: `IMEI: ${d.imei1 || d.serial || "-"}`,
        },
        {
          title: d.product_name || "Warranty",
          sub: d.category_name || "Warranty",
          // extra: `IMEI: ${d.imei1 || d.serial || "-"}`,
        },
        

        <Badge variant={approval.variant}>
          {approval.label}
        </Badge>,
      ],
    };
  });
}, [devices]);

  const fetchClaims = async () => {
  try {
    setClaimsLoading(true);

    let url = `${BASE_URL}warranty/claims/list?page=${claimsPage}`;

    if (userRole === 2) {
      url += `&company_id=${sessionId}`;
    }

    const res = await fetch(url);
    const json = await res.json();

    if (json?.status) {
      setClaims(json.data?.data || []);
      setClaimsTotalPages(json.data?.last_page || 1);
    } else {
      setClaims([]);
    }
  } catch (err) {
    console.error("Failed to fetch claims", err);
    setClaims([]);
  } finally {
    setClaimsLoading(false);
  }
};

  useEffect(() => {
  fetchClaims();
}, [claimsPage, userRole, sessionId]);

  const normalizedClaims = useMemo(() => {
    return claims.map((c) => ({
      // ---------- normalized fields ----------
      code: c.claim_code,
      RawID: c.id,
      status:
    !c.status
      ? "Pending"
      : c.status
          .replaceAll("_", " ")
          .toLowerCase()
          .replace(/\b\w/g, (l) => l.toUpperCase()),
      customer: c.customer?.name || "—",
      device: `${c.device?.product_name || "—"} · ${c.device?.imei1 || "—"}`,
      issue: c.issue_description || "—",
      approvedAmount: Number(c.estimate_amount || 0),
      payableAmount: Number(c.payable_amount || 0),
      lastUpdated: c.updated_at?.slice(0, 10),

      // ---------- 🔥 RAW CLAIM (HIDDEN) ----------
      raw: c,
    }));
  }, [claims]);

  const claimRows = useMemo(() => {
    return normalizedClaims.map((c) => ({
      raw: c.raw, // 🔥 PASS RAW HERE
      cells: [
        {
          title: c.code,
          sub: `Updated: ${c.lastUpdated}`,
        },
        {
          title: c.customer,
          sub: c.device,
        },
        {
          title: c.issue,
        },
        {
          title: `₹ ${formatCurrency(c.approvedAmount)}`,
          sub: `Payable: ₹ ${formatCurrency(c.payableAmount)}`,
        },
        <Badge
          variant={
            c.status === "Rejected"
              ? "danger"
              : c.status === "Pending"
              ? "info"
              : "success"
          }
        >
          {c.status}
        </Badge>,
      ],
    }));
  }, [normalizedClaims]);

  const claimCards = useMemo(() => {
    return normalizedClaims.map((c) => (
      <ExpandableCard
        key={c.id}
        title={c.id}
        badge={{
          label: c.status,
          color:
            c.status === "Approved"
              ? "green"
              : c.status === "Rejected"
              ? "red"
              : "yellow",
        }}
        primaryFields={[
          { label: "Customer", value: c.customer },
          { label: "Device", value: c.device },
          { label: "Issue", value: c.issue },
        ]}
        extraFields={[
          { label: "Warranty", value: c.warrantyId },
          { label: "Approved", value: `₹ ${formatCurrency(c.approvedAmount)}` },
          { label: "Payable", value: `₹ ${formatCurrency(c.payableAmount)}` },
        ]}
        onView={() => setSelectedClaim(c.id)}
      />
    ));
  }, [normalizedClaims]);

  const fetchWarrantyDashboard = async () => {
  try {
    setDashboardLoading(true);

    let url = `${BASE_URL}warranty/warranty-dashboard`

    // ✅ Only company role sends company_id
    if (userRole === 2) {
      url += `?company_id=${sessionId}`;
    }

    const res = await fetch(url);
    const json = await res.json();

    if (!json?.status) {
      throw new Error(json?.message || "Failed to fetch dashboard data");
    }

    setDashboardStats(json.data);
  } catch (err) {
    console.error("Dashboard API error:", err);
    toast.error("Failed to load dashboard stats");
  } finally {
    setDashboardLoading(false);
  }
};


useEffect(() => {
  if (userRole === 1 || userRole === 2) {
    fetchWarrantyDashboard();
  }
}, [userRole, sessionId]);


  const onPageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // ⚡ Filter logic
  const filteredWarranties = showOnlyActive
    ? warrantiesData.filter((w) => w.status === "Active")
    : warrantiesData;

  const filteredClaims = showOnlyOpen
    ? claims.filter((w) => w.status === "Pending")
    : claims;

  const [claimList, setClaimList] = useState(claims);
  const [selectedClaim, setSelectedClaim] = useState(null);
  const totalApproved = claims.reduce(
    (sum, c) => sum + (c.approvedAmount || 0),
    0
  );
  const totalPayable = claims.reduce(
    (sum, c) => sum + (c.payableAmount || 0),
    0
  );

  // const selectedClaim =
  //   claims.find((c) => c.id === selectedClaimId) || null;

  const handleClaimAction = (id, action) => {
    setClaimList((prev) =>
      prev.map((c) => {
        if (c.id !== id) return c;
        if (action === "approve") {
          return {
            ...c,
            status: "Approved",
            payableStatus: c.payableStatus === "Not Applicable" ? "Pending" : c.payableStatus,
            lastUpdated: todayISO(),
          };
        }
        if (action === "reject") {
          return {
            ...c,
            status: "Rejected",
            payableStatus: "Not Applicable",
            reason: c.reason || "Rejected by admin",
            lastUpdated: todayISO(),
          };
        }
        return c;
      })
    );
  };

  const handleUpdateClaim = (id, updates) => {
      setClaimList((prev) =>
        prev.map((c) => (c.id === id ? { ...c, ...updates, lastUpdated: todayISO() } : c))
      );
    };

    const handleFinalApprove = async () => {
    if (!approvingClaim) return;

    const toastId = toast.loading("Approving claim...");

    try {
      // 🔹 OPTIONAL: API call if backend exists
      // await fetch(`${BASE_URL}warranty/claims/approve`, { ... })

      handleClaimAction(approvingClaim.id, "approve");

      toast.success("Claim approved successfully", { id: toastId });

      setClaims((prev) =>
        prev.map((cl) =>
          cl.id === assigningClaim.raw.id
            ? {
                ...cl,
                assigned_employee: employees.find(
                  (e) => e.id === selectedEmployee
                ),
              }
            : cl
        )
      );
      setShowApproveModal(false);
      setApprovingClaim(null);
    } catch (err) {
      toast.error("Failed to approve claim", { id: toastId });
    }
  };


  const handleApproveClaim = async (claim, reasonId, remark) => {
  const toastId = toast.loading("Approving claim...");

  try {
    const res = await fetch(
      `${BASE_URL}warranty/company/approve-claim`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          claim_id: claim.id,
          reason_id: reasonId,
          remark: remark || "",
        }),
      }
    );

    const json = await res.json();

    if (!json?.status) {
      throw new Error(json?.message || "Approve failed");
    }

    toast.success("Claim approved successfully", { id: toastId });

    // 🔄 Refresh list
    fetchClaims();

    // 🔒 Close modal
    setShowApproveModal(false);
    setApprovingClaim(null);
  } catch (err) {
    toast.error(err.message || "Failed to approve claim", {
      id: toastId,
    });
  }
};


const handleRejectClaim = async (claim, reasonId, remark) => {
  const toastId = toast.loading("Rejecting claim...");

  try {
    const res = await fetch(
      `${BASE_URL}warranty/company/reject-claim`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          claim_id: claim.id,
          reason_id: reasonId,
          remark: remark || "",
        }),
      }
    );

    const json = await res.json();

    if (!json?.status) {
      throw new Error(json?.message || "Reject failed");
    }

    toast.success("Claim rejected successfully", { id: toastId });

    // 🔄 Refresh list
    fetchClaims();

    // 🔒 Close modal
    setShowApproveModal(false);
    setApprovingClaim(null);
  } catch (err) {
    toast.error(err.message || "Failed to reject claim", {
      id: toastId,
    });
  }
};

  const canShowClaimConsole = useMemo(() => {
  if (!selectedClaim?.status) return false;

  const normalizedStatus = String(selectedClaim.status)
    .toLowerCase()
    .replaceAll(" ", "_");

  return ALLOWED_CLAIM_CONSOLE_STATUSES.includes(normalizedStatus);
}, [selectedClaim]);

console.log("selected claim in warranty: ",selectedClaim)

  return (
    <div className="space-y-4">
      <KpiSection
  dashboardStats={dashboardStats}
  loading={dashboardLoading}
  totalApproved={totalApproved}
  totalPayable={totalPayable}
/>


      {/* -------- Tabs -------- */}
      <div className="flex gap-2 border-b border-slate-200">
        <button
          onClick={() => setActiveTab("warranties")}
          className={`px-4 py-2 text-sm font-medium border-b-2 transition
            ${
              activeTab === "warranties"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-slate-500 hover:text-slate-700"
            }`}
        >
          Warranties
        </button>

        <button
          onClick={() => setActiveTab("claims")}
          className={`px-4 py-2 text-sm font-medium border-b-2 transition
            ${
              activeTab === "claims"
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-slate-500 hover:text-slate-700"
            }`}
        >
          Claims
        </button>
      </div>


      {activeTab === "warranties" && (
        <WarrantyTable
          showOnlyOpen={showOnlyOpen}
          loadingDevices={loadingDevices}
          deviceRows={deviceRows}
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
          fetchDevices={fetchDevices}
          Navigate={Navigate}
          approvalFilter={approvalFilter}
          setApprovalFilter={setApprovalFilter}
          search={search}
          setSearch={setSearch}
        />
      )}

      {activeTab === "claims" && (
      <ClaimsTable
        showOnlyActive={showOnlyActive}
        claimsLoading={claimsLoading}
        claimRows={claimRows}
        claimsPage={claimsPage}
        claimsTotalPages={claimsTotalPages}
        setClaimsPage={setClaimsPage}
        setSelectedClaim={setSelectedClaim}
        fetchClaims={fetchClaims}
        claimCards={claimCards}
        setApprovingClaim={setApprovingClaim}
        setShowApproveModal={setShowApproveModal}
        setAssigningClaim={setAssigningClaim}
        setShowAssignModal={setShowAssignModal}
      />
      )}

    {activeTab === "claims" && showApproveModal && approvingClaim && (
        <ApproveRejectModal
          claim={approvingClaim}   // ✅ ALWAYS raw
          isAdmin={isAdmin}
          isCompany={isCompany}
          onClose={() => {
            setShowApproveModal(false);
            setApprovingClaim(null);
          }}
          onAssign={() => {
            setAssigningClaim(approvingClaim);
            setShowApproveModal(false);
          }}

            onApprove={handleApproveClaim}   // ✅
            onReject={handleRejectClaim}
        />
      )}

      {activeTab === "claims" && selectedClaim && canShowClaimConsole && (
        <ClaimConsole
          selectedClaim={selectedClaim}
          setSelectedClaim={setSelectedClaim}
          handleUpdateClaim={handleUpdateClaim}
        />
      )}

      {activeTab === "claims" && selectedClaim && !canShowClaimConsole && (
        <SectionCard title="Claim Handling Console">
          <p className="text-sm text-slate-500">
            Claim actions will be available once the device is handed over to the company.
          </p>
        </SectionCard>
      )}



      {activeTab === "claims" && assigningClaim && (
        <AssignEmployeeModal
          assigningClaim={assigningClaim}
          employees={employees}
          loadingEmployees={loadingEmployees}
          selectedEmployee={selectedEmployee}
          setSelectedEmployee={setSelectedEmployee}
          onAssign={handleAssignEmployee}
          onClose={() => {
            setShowAssignModal(false);
            setAssigningClaim(null);
          }}
        />
      )}

    </div>
  );
}



// import React, { useEffect, useMemo, useState } from "react";
// import { KpiCard } from "../../../../Component/AgentComponents/KpiCard";
// import { SectionCard } from "../../../../Component/AgentComponents/SectionCard";


// import {
//   ShieldCheck,
//   FileText,
//   IndianRupee,
//   Edit3,
//   Link2,
//   Eye,
// } from "lucide-react";
// import { formatCurrency } from "../../../../Component/AdminComponents/formatCurrency";
// import { Navigate, useLocation, useNavigate } from "react-router-dom";
// import RegularLoader from "../../../../Component/Loader/RegularLoader";
// import Pagination from "../../../../Component/Common/Pagination";
// import RefreshButton from "../../../../Component/Common/RefreshButton";
// import { BASE_URL, Warrenty_URL } from "../../../../config/api";
// import SimpleTable from "../../../../Component/Common/SimpleTable";

// import ExpandableCard from "../../../../Component/Common/ExpandableCard";
// import toast from "react-hot-toast";
// import BlueButton from "../../../../Component/Common/BlueButton";
// import KpiSection from "./KpiSection";
// import WarrantyTable from "./WarrantyTable";
// import ClaimsTable from "./ClaimsTable";
// import ClaimConsole from "./ClaimAdminConsole";
// import AssignEmployeeModal from "./AssignEmployeeModal";
// import ApproveRejectModal from "./ApproveRejectModal";
// import { Badge } from "../../../../Component/RetailerMainComponents/Badge";


// const claims = [
//   {
//     id: "CLM-5001",
//     warrantyId: "WAR-1001",
//     retailer: "Shree Mobile Store",
//     customer: "Amit Kulkarni",
//     device: "Samsung A55",
//     raisedBy: "Retailer", // Retailer | Customer
//     issue: "Device not powering on",
//     status: "Pending", // Pending | Approved | Rejected | In Progress | Settled
//     reason: "",
//     approvedAmount: 3500,
//     payableAmount: 3000,
//     payableStatus: "Pending",
//     paymentLink: "",
//     lastUpdated: "2025-10-15",
//   },
//   {
//     id: "CLM-5002",
//     warrantyId: "WAR-0998",
//     retailer: "Digital Zone",
//     customer: "Demo Customer",
//     device: "mPOS Demo",
//     raisedBy: "Customer",
//     issue: "Screen flickering",
//     status: "Rejected",
//     reason: "Warranty expired",
//     approvedAmount: 0,
//     payableAmount: 0,
//     payableStatus: "Not Applicable",
//     paymentLink: "",
//     lastUpdated: "2025-01-07",
//   },
//   {
//     id: "CLM-5003",
//     warrantyId: "WAR-1002",
//     retailer: "A1 Electronics",
//     customer: "Riya Shah",
//     device: "Samsung Tab S9",
//     raisedBy: "Customer",
//     issue: "No sound from speakers",
//     status: "Approved",
//     reason: "",
//     approvedAmount: 2200,
//     payableAmount: 2000,
//     payableStatus: "Paid",
//     paymentLink: "https://pay.goex.example/CLM-5003",
//     lastUpdated: "2025-11-10",
//   },
// ];


// const todayISO = () => new Date().toISOString().slice(0, 10);

// export default function WarrantiesClaimsView({
// }) {

//   const [warrantiesData, setWarrantiesData] = useState([]);
//   const [loadingWarranties, setLoadingWarranties] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   const [devices, setDevices] = useState([]);
//   const [loadingDevices, setLoadingDevices] = useState(true);
//   const Navigate = useNavigate();

//   const location = useLocation();

//   const [claims, setClaims] = useState([]);
//   const [claimsLoading, setClaimsLoading] = useState(true);
//   const [claimsPage, setClaimsPage] = useState(1);
//   const [claimsTotalPages, setClaimsTotalPages] = useState(1);

//   const [showAssignModal, setShowAssignModal] = useState(false);
//   const [assigningClaim, setAssigningClaim] = useState(null);

//   const [employees, setEmployees] = useState([]);
//   const [loadingEmployees, setLoadingEmployees] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);

//   const [showApproveModal, setShowApproveModal] = useState(false);
//   const [approvingClaim, setApprovingClaim] = useState(null);
//   const [extraPayable, setExtraPayable] = useState(0);
//   const [extraReason, setExtraReason] = useState("");
//   const [activeTab, setActiveTab] = useState("warranties");
// // "warranties" | "claims"


//   // ⚡ Coming from KPI → showOnlyActive = true
//   const showOnlyActive = location.state?.showOnlyActive === true;
//   const showOnlyOpen = location.state?.showOnlyOpen === true;
//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   const userRole = Number(authUser?.role);
//   const sessionId = authUser?.id;

//   const isAdmin = userRole === 1;
//   const isCompany = userRole === 2;

//   const ALLOWED_CLAIM_CONSOLE_STATUSES = [
//   "device_handover_to_company",
//   "company_received_device",
//   "device_received_by_company",
// ];

//   const isFinalized = (status) =>
//     ["Approved", "Rejected", "Settled"].includes(status);

//   const canAssignEmployee = (claim) =>
//     claim.status === "Approved" && !claim.assigned_employee;

//   useEffect(() => {
//     if (showApproveModal) {
//       setExtraPayable(0);
//       setExtraReason("");
//     }
//   }, [showApproveModal]);


//   const fetchWarranties = async () => {
//     try {
//       setLoadingWarranties(true);

//       // let url = `${BASE_URL}get-customers?page=${currentPage}`;
//       let url = `${BASE_URL}warranty/get-customers?page=${currentPage}`;

//       // 🔹 ROLE-BASED PARAMS
//       if (userRole === 2 || userRole === 4) {
//         // Company / Distributor
//         url += `&company_id=${sessionId}`;
//       }

//       if (userRole === 5) {
//         // Retailer
//         url += `&retailer_id=${sessionId}`;
//       }

//       // ROLE 1 (Admin) → no extra params

//       const res = await fetch(url);
//       const data = await res.json();

//       if (data?.data) {
//         setTotalPages(data.last_page || 1);

//         const transformed = data.data.flatMap((customer) =>
//           customer.devices.map((device) => ({
//             custid: customer.id,
//             RawID: device.id,
//             id: `WAR-${device.id.toString().padStart(4, "0")}`,
//             retailer: customer.name,
//             retailerCode: `RET-${customer.id}`,
//             customer: customer.name,
//             deviceType: device.product_name || "Device",
//             brand: device.brand_name || "Brand",
//             model: device.model || "-",
//             imei: device.imei1 || "-",
//             type: "Sold",
//             is_approved:device.is_approved,
//             soldOn: device.created_at?.slice(0, 10) || "",
//             expiry: device.expiry_date || "",
//             plan: device.product_name || "Warranty",
//             price: device.device_price || 0,
//           }))
//         );

//         setWarrantiesData(transformed);
//       }
//     } catch (error) {
//       console.error("Failed to fetch warranties:", error);
//     } finally {
//       setLoadingWarranties(false);
//     }
//   };


//   useEffect(() => {
//     fetchWarranties();
//   }, [currentPage]); // <-- IMPORTANT

//   useEffect(() => {
//   if (approvingClaim) {
//     setShowApproveModal(true);
//   }
// }, [approvingClaim]);

//   const buildDevicesUrl = ({ role, id, page }) => {
//   let url = `${BASE_URL}warranty/get-devices?page=${page}`;

//   switch (role) {
//     case 2: // company
//       url += `&company_id=${id}`;
//       break;
//     case 4: // agent
//       url += `&agent_id=${id}`;
//       break;
//     case 5: // retailer
//       url += `&retailer_id=${id}`;
//       break;
//     case 6: // created_by
//       url += `&created_by=${id}`;
//       break;
//     // role 1 (admin) → no extra param
//     default:
//       break;
//   }

//   return url;
// };
//   const fetchDevices = async () => {
//   try {
//     setLoadingDevices(true);

//     const url = buildDevicesUrl({
//       role: userRole,
//       id: sessionId,
//       page: currentPage,
//     });

//     const res = await fetch(url);
//     const json = await res.json();

//     setDevices(json?.data || []);
//     setTotalPages(json?.last_page || 1);
//   } catch (err) {
//     console.error("Failed to fetch devices", err);
//     setDevices([]);
//   } finally {
//     setLoadingDevices(false);
//   }
// };

// useEffect(() => {
//   fetchDevices();
// }, [currentPage, userRole, sessionId]);

//   useEffect(() => {
//   if (!assigningClaim) return;

//   const companyId = assigningClaim.company_id;

//   if (!companyId) {
//     console.error("Company ID missing in claim", assigningClaim);
//     return;
//   }

//   fetchEmployees(companyId);
// }, [assigningClaim]);


//   const fetchEmployees = async (companyId) => {
//     try {
//       setLoadingEmployees(true);

//       const res = await fetch(
//         `${BASE_URL}company/employee/all`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             // Authorization header if required
//             // "Authorization": `Bearer ${token}`,
//           },
//           body: JSON.stringify({
//             company_id: companyId, // ✅ FROM CLAIM ROW
//           }),
//         }
//       );

//       const json = await res.json();

//       // ✅ IMPORTANT: employees array is nested
//       setEmployees(json?.data?.data || []);
//     } catch (err) {
//       console.error("Failed to fetch employees", err);
//       setEmployees([]);
//     } finally {
//       setLoadingEmployees(false);
//     }
//   };

//   const openAssignModal = (claim) => {
//   setAssigningClaim(claim);
//   setSelectedEmployee("");
//   setShowAssignModal(true);
//   fetchEmployees();
// };

//   const handleAssignEmployee = async () => {
//   if (!assigningClaim || !selectedEmployee) {
//     toast.error("Missing claim or employee");
//     return;
//   }

//   const toastId = toast.loading("Assigning employee...");

//   try {
//     const res = await fetch(
//       `${BASE_URL}warranty/claim/assign-employee`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           claim_id: assigningClaim.id,       // ✅ numeric backend ID
//           employee_id: selectedEmployee,     // ✅ selected employee
//         }),
//       }
//     );

//     const json = await res.json();

//     if (!json?.status) {
//       throw new Error(json?.message || "Assignment failed");
//     }

//     toast.success("Employee assigned successfully", { id: toastId });

//     // 🔄 Refresh claims list
//     fetchClaims();

//     // 🔒 Close modal
//     setShowAssignModal(false);
//     setAssigningClaim(null);
//     setSelectedEmployee(null);
//   } catch (err) {
//     toast.error(err.message || "Failed to assign employee", {
//       id: toastId,
//     });
//   }
// };

// const approvalMap = {
//   0: { label: "Provisioning", variant: "warning" },
//   1: { label: "Active", variant: "success" },
//   2: { label: "Rejected", variant: "danger" },
// };


//   const deviceRows = useMemo(() => {
//   return devices.map((d) => {
//     const approval = approvalMap[d.is_approved] || {
//       label: "Unknown",
//       variant: "gray",
//     };

//     return {
//       raw: d,
//       cells: [
//         {
//           title: d.w_code,
//           sub: `Sold: ${d.created_at?.slice(0, 10)}`,
//           // extra: `Exp: ${d.expiry_date}`,
//         },
//         {
//           title: d.customer?.retailer?.business_name || "—",
//           sub: d.customer?.name || "—",
//         },
//         {
//           title: `${d.brand_name}`,
//           sub: `Model: ${d.model || "-"}`,
//           // extra: `IMEI: ${d.imei1 || d.serial || "-"}`,
//         },
//         {
//           title: d.product_name || "Warranty",
//           sub: d.category_name || "Warranty",
//           // extra: `IMEI: ${d.imei1 || d.serial || "-"}`,
//         },
        

//         <Badge variant={approval.variant}>
//           {approval.label}
//         </Badge>,
//       ],
//     };
//   });
// }, [devices]);

//   const fetchClaims = async () => {
//   try {
//     setClaimsLoading(true);

//     let url = `${BASE_URL}warranty/claims/list?page=${claimsPage}`;

//     if (userRole === 2) {
//       url += `&company_id=${sessionId}`;
//     }

//     const res = await fetch(url);
//     const json = await res.json();

//     if (json?.status) {
//       setClaims(json.data?.data || []);
//       setClaimsTotalPages(json.data?.last_page || 1);
//     } else {
//       setClaims([]);
//     }
//   } catch (err) {
//     console.error("Failed to fetch claims", err);
//     setClaims([]);
//   } finally {
//     setClaimsLoading(false);
//   }
// };

//   useEffect(() => {
//   fetchClaims();
// }, [claimsPage, userRole, sessionId]);

//   const normalizedClaims = useMemo(() => {
//     return claims.map((c) => ({
//       // ---------- normalized fields ----------
//       code: c.claim_code,
//       RawID: c.id,
//       status:
//     !c.status
//       ? "Pending"
//       : c.status
//           .replaceAll("_", " ")
//           .toLowerCase()
//           .replace(/\b\w/g, (l) => l.toUpperCase()),
//       customer: c.customer?.name || "—",
//       device: `${c.device?.product_name || "—"} · ${c.device?.imei1 || "—"}`,
//       issue: c.issue_description || "—",
//       approvedAmount: Number(c.estimate_amount || 0),
//       payableAmount: Number(c.payable_amount || 0),
//       lastUpdated: c.updated_at?.slice(0, 10),

//       // ---------- 🔥 RAW CLAIM (HIDDEN) ----------
//       raw: c,
//     }));
//   }, [claims]);

//   const claimRows = useMemo(() => {
//     return normalizedClaims.map((c) => ({
//       raw: c.raw, // 🔥 PASS RAW HERE
//       cells: [
//         {
//           title: c.code,
//           sub: `Updated: ${c.lastUpdated}`,
//         },
//         {
//           title: c.customer,
//           sub: c.device,
//         },
//         {
//           title: c.issue,
//         },
//         {
//           title: `₹ ${formatCurrency(c.approvedAmount)}`,
//           sub: `Payable: ₹ ${formatCurrency(c.payableAmount)}`,
//         },
//         <Badge
//           variant={
//             c.status === "Rejected"
//               ? "danger"
//               : c.status === "Pending"
//               ? "info"
//               : "success"
//           }
//         >
//           {c.status}
//         </Badge>,
//       ],
//     }));
//   }, [normalizedClaims]);

//   const claimCards = useMemo(() => {
//     return normalizedClaims.map((c) => (
//       <ExpandableCard
//         key={c.id}
//         title={c.id}
//         badge={{
//           label: c.status,
//           color:
//             c.status === "Approved"
//               ? "green"
//               : c.status === "Rejected"
//               ? "red"
//               : "yellow",
//         }}
//         primaryFields={[
//           { label: "Customer", value: c.customer },
//           { label: "Device", value: c.device },
//           { label: "Issue", value: c.issue },
//         ]}
//         extraFields={[
//           { label: "Warranty", value: c.warrantyId },
//           { label: "Approved", value: `₹ ${formatCurrency(c.approvedAmount)}` },
//           { label: "Payable", value: `₹ ${formatCurrency(c.payableAmount)}` },
//         ]}
//         onView={() => setSelectedClaim(c.id)}
//       />
//     ));
//   }, [normalizedClaims]);

//   const onPageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   };

//   // ⚡ Filter logic
//   const filteredWarranties = showOnlyActive
//     ? warrantiesData.filter((w) => w.status === "Active")
//     : warrantiesData;

//   const filteredClaims = showOnlyOpen
//     ? claims.filter((w) => w.status === "Pending")
//     : claims;

//   const [claimList, setClaimList] = useState(claims);
//   const [selectedClaim, setSelectedClaim] = useState(null);
//   const totalApproved = claims.reduce(
//     (sum, c) => sum + (c.approvedAmount || 0),
//     0
//   );
//   const totalPayable = claims.reduce(
//     (sum, c) => sum + (c.payableAmount || 0),
//     0
//   );

//   // const selectedClaim =
//   //   claims.find((c) => c.id === selectedClaimId) || null;

//   const handleClaimAction = (id, action) => {
//     setClaimList((prev) =>
//       prev.map((c) => {
//         if (c.id !== id) return c;
//         if (action === "approve") {
//           return {
//             ...c,
//             status: "Approved",
//             payableStatus: c.payableStatus === "Not Applicable" ? "Pending" : c.payableStatus,
//             lastUpdated: todayISO(),
//           };
//         }
//         if (action === "reject") {
//           return {
//             ...c,
//             status: "Rejected",
//             payableStatus: "Not Applicable",
//             reason: c.reason || "Rejected by admin",
//             lastUpdated: todayISO(),
//           };
//         }
//         return c;
//       })
//     );
//   };

//   const handleUpdateClaim = (id, updates) => {
//       setClaimList((prev) =>
//         prev.map((c) => (c.id === id ? { ...c, ...updates, lastUpdated: todayISO() } : c))
//       );
//     };

//     const handleFinalApprove = async () => {
//     if (!approvingClaim) return;

//     const toastId = toast.loading("Approving claim...");

//     try {
//       // 🔹 OPTIONAL: API call if backend exists
//       // await fetch(`${BASE_URL}warranty/claims/approve`, { ... })

//       handleClaimAction(approvingClaim.id, "approve");

//       toast.success("Claim approved successfully", { id: toastId });

//       setClaims((prev) =>
//         prev.map((cl) =>
//           cl.id === assigningClaim.raw.id
//             ? {
//                 ...cl,
//                 assigned_employee: employees.find(
//                   (e) => e.id === selectedEmployee
//                 ),
//               }
//             : cl
//         )
//       );
//       setShowApproveModal(false);
//       setApprovingClaim(null);
//     } catch (err) {
//       toast.error("Failed to approve claim", { id: toastId });
//     }
//   };


//   const handleApproveClaim = async (claim, reasonId, remark) => {
//   const toastId = toast.loading("Approving claim...");

//   try {
//     const res = await fetch(
//       `${BASE_URL}warranty/company/approve-claim`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           claim_id: claim.id,
//           reason_id: reasonId,
//           remark: remark || "",
//         }),
//       }
//     );

//     const json = await res.json();

//     if (!json?.status) {
//       throw new Error(json?.message || "Approve failed");
//     }

//     toast.success("Claim approved successfully", { id: toastId });

//     // 🔄 Refresh list
//     fetchClaims();

//     // 🔒 Close modal
//     setShowApproveModal(false);
//     setApprovingClaim(null);
//   } catch (err) {
//     toast.error(err.message || "Failed to approve claim", {
//       id: toastId,
//     });
//   }
// };


// const handleRejectClaim = async (claim, reasonId, remark) => {
//   const toastId = toast.loading("Rejecting claim...");

//   try {
//     const res = await fetch(
//       `${BASE_URL}warranty/company/reject-claim`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           claim_id: claim.id,
//           reason_id: reasonId,
//           remark: remark || "",
//         }),
//       }
//     );

//     const json = await res.json();

//     if (!json?.status) {
//       throw new Error(json?.message || "Reject failed");
//     }

//     toast.success("Claim rejected successfully", { id: toastId });

//     // 🔄 Refresh list
//     fetchClaims();

//     // 🔒 Close modal
//     setShowApproveModal(false);
//     setApprovingClaim(null);
//   } catch (err) {
//     toast.error(err.message || "Failed to reject claim", {
//       id: toastId,
//     });
//   }
// };

//   const canShowClaimConsole = useMemo(() => {
//   if (!selectedClaim?.status) return false;

//   const normalizedStatus = String(selectedClaim.status)
//     .toLowerCase()
//     .replaceAll(" ", "_");

//   return ALLOWED_CLAIM_CONSOLE_STATUSES.includes(normalizedStatus);
// }, [selectedClaim]);

// console.log("selected claim in warranty: ",selectedClaim)

//   return (
//     <div className="space-y-4">
//       <KpiSection
//         warrantiesData={warrantiesData}
//         claims={claims}
//         totalApproved={totalApproved}
//         totalPayable={totalPayable}
//       />

//       {/* -------- Tabs -------- */}
//       <div className="flex gap-2 border-b border-slate-200">
//         <button
//           onClick={() => setActiveTab("warranties")}
//           className={`px-4 py-2 text-sm font-medium border-b-2 transition
//             ${
//               activeTab === "warranties"
//                 ? "border-blue-600 text-blue-600"
//                 : "border-transparent text-slate-500 hover:text-slate-700"
//             }`}
//         >
//           Warranties
//         </button>

//         <button
//           onClick={() => setActiveTab("claims")}
//           className={`px-4 py-2 text-sm font-medium border-b-2 transition
//             ${
//               activeTab === "claims"
//                 ? "border-blue-600 text-blue-600"
//                 : "border-transparent text-slate-500 hover:text-slate-700"
//             }`}
//         >
//           Claims
//         </button>
//       </div>


//       {activeTab === "warranties" && (
//         <WarrantyTable
//           showOnlyOpen={showOnlyOpen}
//           loadingDevices={loadingDevices}
//           deviceRows={deviceRows}
//           currentPage={currentPage}
//           totalPages={totalPages}
//           setCurrentPage={setCurrentPage}
//           fetchDevices={fetchDevices}
//           Navigate={Navigate}
//         />
//       )}

//       {activeTab === "claims" && (
//       <ClaimsTable
//         showOnlyActive={showOnlyActive}
//         claimsLoading={claimsLoading}
//         claimRows={claimRows}
//         claimsPage={claimsPage}
//         claimsTotalPages={claimsTotalPages}
//         setClaimsPage={setClaimsPage}
//         setSelectedClaim={setSelectedClaim}
//         fetchClaims={fetchClaims}
//         claimCards={claimCards}
//         setApprovingClaim={setApprovingClaim}
//         setShowApproveModal={setShowApproveModal}
//         setAssigningClaim={setAssigningClaim}
//         setShowAssignModal={setShowAssignModal}
//       />
//       )}

//      {activeTab === "claims" && showApproveModal && approvingClaim && (
//         <ApproveRejectModal
//           claim={approvingClaim}   // ✅ ALWAYS raw
//           isAdmin={isAdmin}
//           isCompany={isCompany}
//           onClose={() => {
//             setShowApproveModal(false);
//             setApprovingClaim(null);
//           }}
//           onAssign={() => {
//             setAssigningClaim(approvingClaim);
//             setShowApproveModal(false);
//           }}

//             onApprove={handleApproveClaim}   // ✅
//             onReject={handleRejectClaim}
//         />
//       )}

//       {activeTab === "claims" && selectedClaim && canShowClaimConsole && (
//         <ClaimConsole
//           selectedClaim={selectedClaim}
//           setSelectedClaim={setSelectedClaim}
//           handleUpdateClaim={handleUpdateClaim}
//         />
//       )}

//       {activeTab === "claims" && selectedClaim && !canShowClaimConsole && (
//         <SectionCard title="Claim Handling Console">
//           <p className="text-sm text-slate-500">
//             Claim actions will be available once the device is handed over to the company.
//           </p>
//         </SectionCard>
//       )}



//       {activeTab === "claims" && assigningClaim && (
//         <AssignEmployeeModal
//           assigningClaim={assigningClaim}
//           employees={employees}
//           loadingEmployees={loadingEmployees}
//           selectedEmployee={selectedEmployee}
//           setSelectedEmployee={setSelectedEmployee}
//           onAssign={handleAssignEmployee}
//           onClose={() => {
//             setShowAssignModal(false);
//             setAssigningClaim(null);
//           }}
//         />
//       )}

//     </div>
//   );
// }


// import React, { useEffect, useMemo, useState } from "react";
// import { KpiCard } from "../../../../Component/AgentComponents/KpiCard";
// import { SectionCard } from "../../../../Component/AgentComponents/SectionCard";


// import {
//   ShieldCheck,
//   FileText,
//   IndianRupee,
//   Edit3,
//   Link2,
//   Eye,
// } from "lucide-react";
// import { formatCurrency } from "../../../../Component/AdminComponents/formatCurrency";
// import { Navigate, useLocation, useNavigate } from "react-router-dom";
// import RegularLoader from "../../../../Component/Loader/RegularLoader";
// import Pagination from "../../../../Component/Common/Pagination";
// import RefreshButton from "../../../../Component/Common/RefreshButton";
// import { BASE_URL, Warrenty_URL } from "../../../../config/api";
// import SimpleTable from "../../../../Component/Common/SimpleTable";
// import Badge from "../../../../Component/Common/Badge";
// import ExpandableCard from "../../../../Component/Common/ExpandableCard";
// import toast from "react-hot-toast";
// import BlueButton from "../../../../Component/Common/BlueButton";


// const claims = [
//   {
//     id: "CLM-5001",
//     warrantyId: "WAR-1001",
//     retailer: "Shree Mobile Store",
//     customer: "Amit Kulkarni",
//     device: "Samsung A55",
//     raisedBy: "Retailer", // Retailer | Customer
//     issue: "Device not powering on",
//     status: "Pending", // Pending | Approved | Rejected | In Progress | Settled
//     reason: "",
//     approvedAmount: 3500,
//     payableAmount: 3000,
//     payableStatus: "Pending",
//     paymentLink: "",
//     lastUpdated: "2025-10-15",
//   },
//   {
//     id: "CLM-5002",
//     warrantyId: "WAR-0998",
//     retailer: "Digital Zone",
//     customer: "Demo Customer",
//     device: "mPOS Demo",
//     raisedBy: "Customer",
//     issue: "Screen flickering",
//     status: "Rejected",
//     reason: "Warranty expired",
//     approvedAmount: 0,
//     payableAmount: 0,
//     payableStatus: "Not Applicable",
//     paymentLink: "",
//     lastUpdated: "2025-01-07",
//   },
//   {
//     id: "CLM-5003",
//     warrantyId: "WAR-1002",
//     retailer: "A1 Electronics",
//     customer: "Riya Shah",
//     device: "Samsung Tab S9",
//     raisedBy: "Customer",
//     issue: "No sound from speakers",
//     status: "Approved",
//     reason: "",
//     approvedAmount: 2200,
//     payableAmount: 2000,
//     payableStatus: "Paid",
//     paymentLink: "https://pay.goex.example/CLM-5003",
//     lastUpdated: "2025-11-10",
//   },
// ];


// const todayISO = () => new Date().toISOString().slice(0, 10);

// export default function WarrantiesClaimsView({
// }) {

//   const [warrantiesData, setWarrantiesData] = useState([]);
//   const [loadingWarranties, setLoadingWarranties] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   const [devices, setDevices] = useState([]);
//   const [loadingDevices, setLoadingDevices] = useState(true);
//   const Navigate = useNavigate();

//   const location = useLocation();

//   const [claims, setClaims] = useState([]);
//   const [claimsLoading, setClaimsLoading] = useState(true);
//   const [claimsPage, setClaimsPage] = useState(1);
//   const [claimsTotalPages, setClaimsTotalPages] = useState(1);

//   const [showAssignModal, setShowAssignModal] = useState(false);
//   const [assigningClaim, setAssigningClaim] = useState(null);

//   const [employees, setEmployees] = useState([]);
//   const [loadingEmployees, setLoadingEmployees] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState("");

//   const [showApproveModal, setShowApproveModal] = useState(false);
//   const [approvingClaim, setApprovingClaim] = useState(null);
//   const [extraPayable, setExtraPayable] = useState(0);
//   const [extraReason, setExtraReason] = useState("");

//   // ⚡ Coming from KPI → showOnlyActive = true
//   const showOnlyActive = location.state?.showOnlyActive === true;
//   const showOnlyOpen = location.state?.showOnlyOpen === true;
//   const authUserString = localStorage.getItem("authUserData");
//   const authUser = authUserString ? JSON.parse(authUserString) : null;

//   const userRole = Number(authUser?.role);
//   const sessionId = authUser?.id;

//   const isAdmin = userRole === 1;
//   const isCompany = userRole === 2;


//   const isFinalized = (status) =>
//     ["Approved", "Rejected", "Settled"].includes(status);

//   const canAssignEmployee = (claim) =>
//     claim.status === "Approved" && !claim.assigned_employee;

//   useEffect(() => {
//     if (showApproveModal) {
//       setExtraPayable(0);
//       setExtraReason("");
//     }
//   }, [showApproveModal]);


//   const fetchWarranties = async () => {
//     try {
//       setLoadingWarranties(true);

//       // let url = `${BASE_URL}get-customers?page=${currentPage}`;
//       let url = `${BASE_URL}warranty/get-customers?page=${currentPage}`;

//       // 🔹 ROLE-BASED PARAMS
//       if (userRole === 2 || userRole === 4) {
//         // Company / Distributor
//         url += `&company_id=${sessionId}`;
//       }

//       if (userRole === 5) {
//         // Retailer
//         url += `&retailer_id=${sessionId}`;
//       }

//       // ROLE 1 (Admin) → no extra params

//       const res = await fetch(url);
//       const data = await res.json();

//       if (data?.data) {
//         setTotalPages(data.last_page || 1);

//         const transformed = data.data.flatMap((customer) =>
//           customer.devices.map((device) => ({
//             custid: customer.id,
//             RawID: device.id,
//             id: `WAR-${device.id.toString().padStart(4, "0")}`,
//             retailer: customer.name,
//             retailerCode: `RET-${customer.id}`,
//             customer: customer.name,
//             deviceType: device.product_name || "Device",
//             brand: device.brand_name || "Brand",
//             model: device.model || "-",
//             imei: device.imei1 || "-",
//             type: "Sold",
//             status: device.status || "Active",
//             soldOn: device.created_at?.slice(0, 10) || "",
//             expiry: device.expiry_date || "",
//             plan: device.product_name || "Warranty",
//             price: device.device_price || 0,
//           }))
//         );

//         setWarrantiesData(transformed);
//       }
//     } catch (error) {
//       console.error("Failed to fetch warranties:", error);
//     } finally {
//       setLoadingWarranties(false);
//     }
//   };


//   useEffect(() => {
//     fetchWarranties();
//   }, [currentPage]); // <-- IMPORTANT

//   const buildDevicesUrl = ({ role, id, page }) => {
//   let url = `${BASE_URL}warranty/get-devices?page=${page}`;

//   switch (role) {
//     case 2: // company
//       url += `&company_id=${id}`;
//       break;
//     case 4: // agent
//       url += `&agent_id=${id}`;
//       break;
//     case 5: // retailer
//       url += `&retailer_id=${id}`;
//       break;
//     case 6: // created_by
//       url += `&created_by=${id}`;
//       break;
//     // role 1 (admin) → no extra param
//     default:
//       break;
//   }

//   return url;
// };
//   const fetchDevices = async () => {
//   try {
//     setLoadingDevices(true);

//     const url = buildDevicesUrl({
//       role: userRole,
//       id: sessionId,
//       page: currentPage,
//     });

//     const res = await fetch(url);
//     const json = await res.json();

//     setDevices(json?.data || []);
//     setTotalPages(json?.last_page || 1);
//   } catch (err) {
//     console.error("Failed to fetch devices", err);
//     setDevices([]);
//   } finally {
//     setLoadingDevices(false);
//   }
// };

// useEffect(() => {
//   fetchDevices();
// }, [currentPage, userRole, sessionId]);

//   const fetchEmployees = async () => {
//     try {
//       setLoadingEmployees(true);

//       const res = await fetch(
//         `${BASE_URL}employees/list?company_id=${sessionId}`
//       );
//       const json = await res.json();

//       setEmployees(json?.data || []);
//     } catch (err) {
//       console.error("Failed to fetch employees", err);
//       setEmployees([]);
//     } finally {
//       setLoadingEmployees(false);
//     }
//   };

//   const openAssignModal = (claim) => {
//   setAssigningClaim(claim);
//   setSelectedEmployee("");
//   setShowAssignModal(true);
//   fetchEmployees();
// };

//   const handleAssignEmployee = async () => {
//   if (!selectedEmployee) {
//     toast.error("Please select an employee");
//     return;
//   }

//   const toastId = toast.loading("Assigning employee...");

//   try {
//     await fetch(`${BASE_URL}warranty/claims/assign-employee`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         claim_id: assigningClaim.raw.id,
//         employee_id: selectedEmployee,
//       }),
//     });

//     toast.success("Employee assigned successfully", { id: toastId });

//     setShowAssignModal(false);
//     setAssigningClaim(null);
//   } catch (err) {
//     toast.error("Failed to assign employee", { id: toastId });
//   }
// };


//   const deviceRows = useMemo(() => {
//   return devices.map((d) => ({
//     raw: d,
//     cells: [
//       {
//         title: (d.w_code),
//         sub: `Sold: ${d.created_at?.slice(0, 10)}`,
//         extra: `Exp: ${d.expiry_date}`,
//       },
//       {
//         title: d.customer?.retailer?.business_name || "—",
//         sub: d.customer?.name || "—",
//       },
//       {
//         title: `${d.product_name || "Device"} · ${d.brand_name}`,
//         sub: `Model: ${d.model || "-"}`,
//         extra: `IMEI: ${d.imei1 || d.serial || "-"}`,
//       },
//       d.product_name || "Warranty",
//       <Badge
//         label={d.available_claim > 0 ? "Active" : "Expired"}
//         color={d.available_claim > 0 ? "green" : "red"}
//       />,
//     ],
//   }));
// }, [devices]);

//   const fetchClaims = async () => {
//   try {
//     setClaimsLoading(true);

//     let url = `${BASE_URL}warranty/claims/list?page=${claimsPage}`;

//     if (userRole === 2) {
//       url += `&company_id=${sessionId}`;
//     }

//     const res = await fetch(url);
//     const json = await res.json();

//     if (json?.status) {
//       setClaims(json.data?.data || []);
//       setClaimsTotalPages(json.data?.last_page || 1);
//     } else {
//       setClaims([]);
//     }
//   } catch (err) {
//     console.error("Failed to fetch claims", err);
//     setClaims([]);
//   } finally {
//     setClaimsLoading(false);
//   }
// };

//   useEffect(() => {
//   fetchClaims();
// }, [claimsPage, userRole, sessionId]);

//   const normalizedClaims = useMemo(() => {
//   return claims.map((c) => ({
//     id: `CLM-${c.id}`,
//     warrantyId: `WAR-${c.w_device_id}`,
//     retailer:
//       c.drop_retailer?.business_name ||
//       c.customer?.name ||
//       "—",
//     customer: c.customer?.name || "—",
//     device: `${c.device?.product_name || ""} ${c.device?.model || ""}`,
//     raisedBy: c.claim_type === "pickup" ? "Customer" : "Retailer",
//     issue: c.issue_description,
//     status:
//       c.status === "otp_sent"
//         ? "Pending"
//         : c.status.replace("_", " "),
//     reason: "",
//     approvedAmount: c.estimate_amount || 0,
//     payableAmount: c.estimate_amount || 0,
//     payableStatus: "Pending",
//     paymentLink: "",
//     lastUpdated: c.updated_at?.slice(0, 10),
//   }));
// }, [claims]);

//   const claimRows = useMemo(() => {
//     return normalizedClaims.map((c) => ({
//       raw: c,
//       cells: [
//         {
//           title: c.id,
//           sub: `Warranty: ${c.warrantyId}`,
//         },
//         {
//           title: c.retailer,
//           sub: c.customer,
//         },
//         {
//           title: c.device,
//           sub: c.issue,
//         },
//         {
//           title: `₹ ${formatCurrency(c.approvedAmount)}`,
//           sub: `Payable: ₹ ${formatCurrency(c.payableAmount)}`,
//         },
//         <Badge
//           label={c.status}
//           color={
//             c.status === "Approved"
//               ? "green"
//               : c.status === "Rejected"
//               ? "red"
//               : "yellow"
//           }
//         />,
//       ],
//     }));
//   }, [normalizedClaims]);

//   const claimCards = useMemo(() => {
//   return normalizedClaims.map((c) => (
//     <ExpandableCard
//       key={c.id}
//       title={c.id}
//       badge={{
//         label: c.status,
//         color:
//           c.status === "Approved"
//             ? "green"
//             : c.status === "Rejected"
//             ? "red"
//             : "yellow",
//       }}
//       primaryFields={[
//         { label: "Customer", value: c.customer },
//         { label: "Device", value: c.device },
//         { label: "Issue", value: c.issue },
//       ]}
//       extraFields={[
//         { label: "Warranty", value: c.warrantyId },
//         { label: "Approved", value: `₹ ${formatCurrency(c.approvedAmount)}` },
//         { label: "Payable", value: `₹ ${formatCurrency(c.payableAmount)}` },
//       ]}
//       onView={() => setSelectedClaim(c.id)}
//     />
//   ));
// }, [normalizedClaims]);


//   const onPageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   };

//   // ⚡ Filter logic
//   const filteredWarranties = showOnlyActive
//     ? warrantiesData.filter((w) => w.status === "Active")
//     : warrantiesData;

//   const filteredClaims = showOnlyOpen
//     ? claims.filter((w) => w.status === "Pending")
//     : claims;


//   const [claimList, setClaimList] = useState(claims);
//   const [selectedClaim, setSelectedClaim] = useState(null);
//   const totalApproved = claims.reduce(
//     (sum, c) => sum + (c.approvedAmount || 0),
//     0
//   );
//   const totalPayable = claims.reduce(
//     (sum, c) => sum + (c.payableAmount || 0),
//     0
//   );

//   // const selectedClaim =
//   //   claims.find((c) => c.id === selectedClaimId) || null;

//   const handleClaimAction = (id, action) => {
//     setClaimList((prev) =>
//       prev.map((c) => {
//         if (c.id !== id) return c;
//         if (action === "approve") {
//           return {
//             ...c,
//             status: "Approved",
//             payableStatus: c.payableStatus === "Not Applicable" ? "Pending" : c.payableStatus,
//             lastUpdated: todayISO(),
//           };
//         }
//         if (action === "reject") {
//           return {
//             ...c,
//             status: "Rejected",
//             payableStatus: "Not Applicable",
//             reason: c.reason || "Rejected by admin",
//             lastUpdated: todayISO(),
//           };
//         }
//         return c;
//       })
//     );
//   };

//   const handleUpdateClaim = (id, updates) => {
//       setClaimList((prev) =>
//         prev.map((c) => (c.id === id ? { ...c, ...updates, lastUpdated: todayISO() } : c))
//       );
//     };

//     const handleFinalApprove = async () => {
//     if (!approvingClaim) return;

//     const toastId = toast.loading("Approving claim...");

//     try {
//       // 🔹 OPTIONAL: API call if backend exists
//       // await fetch(`${BASE_URL}warranty/claims/approve`, { ... })

//       handleClaimAction(approvingClaim.id, "approve");

//       toast.success("Claim approved successfully", { id: toastId });

//       setClaims((prev) =>
//         prev.map((cl) =>
//           cl.id === assigningClaim.raw.id
//             ? {
//                 ...cl,
//                 assigned_employee: employees.find(
//                   (e) => e.id === selectedEmployee
//                 ),
//               }
//             : cl
//         )
//       );
//       setShowApproveModal(false);
//       setApprovingClaim(null);
//     } catch (err) {
//       toast.error("Failed to approve claim", { id: toastId });
//     }
//   };


//   return (
//     <div className="space-y-4">

//       {/* KPI Cards */}
//       <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//         <KpiCard
//           label="Total Warranties"
//           value={warrantiesData.length}
//           subLabel={`Active: ${
//             warrantiesData.filter((w) => w.status === "Active").length
//           }`}
//           icon={ShieldCheck}
//         />

//         <KpiCard
//           label="Claims Raised"
//           value={claims.length}
//           subLabel={`Open: ${
//             claims.filter(
//               (c) =>
//                 c.status === "Pending" ||
//                 c.status === "In Progress" ||
//                 c.status === "Approved"
//             ).length
//           }`}
//           icon={FileText}
//         />

//         <KpiCard
//           label="Approved Amount"
//           value={`₹ ${formatCurrency(totalApproved)}`}
//           subLabel="All claims"
//           icon={IndianRupee}
//         />

//         <KpiCard
//           label="Payable Amount"
//           value={`₹ ${formatCurrency(totalPayable)}`}
//           subLabel="To be paid / paid"
//           icon={IndianRupee}
//         />
//       </div>

//       {/* Warranty Registry */}
//       {!showOnlyOpen && (
//         <SectionCard title="Warranty Registry (Retailer + Customer)">
//           <div className="flex justify-end">
//             <RefreshButton onClick={fetchDevices} />
//           </div>

//           {loadingDevices ? (
//             <RegularLoader />
//           ) : (
//             <SimpleTable
//               headers={[
//                 "Warranty",
//                 "Retailer / Customer",
//                 "Device",
//                 "Plan",
//                 "Status",
//               ]}
//               rows={deviceRows}
//               currentPage={currentPage}
//               totalPages={totalPages}
//               onPageChange={setCurrentPage}
//               showSrNo
//               renderActions={(row) => (
//                 <button
//                   onClick={(e) => {
//                     e.stopPropagation(); // prevent row click
//                     Navigate(`/warranty-details/${row.w_customer_id}`);
//                   }}
//                   className="px-3 py-1 text-sm  bg-blue-600 text-white rounded-md hover:bg-blue-700"
//                 >
//                   View
//                 </button>
//               )}
//             />

//           )}
//         </SectionCard>

//       )}


//       {/* Claims Table */}
//       {!showOnlyActive && (
//       <SectionCard title="Claims – Approvals, Rejections & Reasons">

//         <div className="flex justify-end">
//             <RefreshButton onClick={fetchClaims} />
//           </div>
//         {claimsLoading ? (
//           <RegularLoader />
//         ) : (
//           <>
//             {/* DESKTOP */}
//             <div className="hidden md:block">
//               <SimpleTable
//                 headers={[
//                   "Claim",
//                   "Retailer / Customer",
//                   "Issue",
//                   "Amounts",
//                   "Status",
//                 ]}
//                 rows={claimRows}
//                 currentPage={claimsPage}
//                 totalPages={claimsTotalPages}
//                 onPageChange={setClaimsPage}
//                 showSrNo
//                 onRowClick={(row) => {
//                     setSelectedClaim(row);
//                   }}
//                 // renderActions={(c) => (
//                 //   <button
//                 //     onClick={(e) => {
//                 //       e.stopPropagation();          // prevent double trigger
//                 //       setSelectedClaim(c.raw); // 🔥 ALSO SET HERE
//                 //       setApprovingClaim(c);
//                 //       setShowApproveModal(true);
//                 //     }}
//                 //     className="text-[10px] px-2 py-0.5 rounded-lg border border-slate-200 bg-slate-50"
//                 //   >
//                 //     <Eye className="w-4 h-4" />
//                 //     View
//                 //   </button>
//                 // )}
//               />

//             </div>

//             {/* MOBILE */}
//             <div className="md:hidden space-y-2">
//               {claimCards}
//             </div>
//           </>
//         )}
//       </SectionCard>

//       )}

//       {/* Claim Console */}
//       {selectedClaim && (
      // <SectionCard
      //   title="Claim Handling Console"
      //   right={
      //     <span className="text-sm  text-slate-400 flex items-center gap-1">
      //       <FileText className="w-3 h-3" />
      //       Admin-only
      //     </span>
      //   }
      // >
      //   {!claims.length ? (
      //     <p className="text-sm  text-slate-500">No claims available.</p>
      //   ) : !selectedClaim ? (
      //     <p className="text-sm  text-slate-500">
      //       Select a claim above to update approved amount, payable
      //       amount, payment link and statuses.
      //     </p>
      //   ) : (
      //     <div className="text-sm  space-y-3">

      //       {/* Summary */}
      //       <div className="flex flex-wrap justify-between gap-2">
      //         <div>
      //           <p className="text-sm  text-slate-500">Claim</p>
      //           <p className="text-sm font-semibold">
      //             {selectedClaim.id} · {selectedClaim.device}
      //           </p>
      //           <p className="text-sm  text-slate-500">
      //             {selectedClaim.retailer} · {selectedClaim.customer}
      //           </p>
      //         </div>

      //         <div className="flex flex-col items-end text-sm  text-slate-500">
      //           <span>Last updated: {selectedClaim.lastUpdated}</span>
      //           <span>Raised by: {selectedClaim.raisedBy}</span>
      //         </div>
      //       </div>

      //       {/* Editable Fields */}
      //       <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      //         <div>
      //           <label className="text-sm ">Approved amount (₹)</label>
      //           <input
      //             type="number"
      //             value={selectedClaim.approvedAmount ?? ""}
      //             onChange={(e) =>
      //               handleUpdateClaim?.(selectedClaim.id, {
      //                 approvedAmount: Number(e.target.value) || 0,
      //               })
      //             }
      //             className="w-full border rounded-xl px-2 py-1 text-xs"
      //           />
      //         </div>

      //         <div>
      //           <label className="text-sm ">Payable amount (₹)</label>
      //           <input
      //             type="number"
      //             value={selectedClaim.payableAmount ?? ""}
      //             onChange={(e) =>
      //               handleUpdateClaim?.(selectedClaim.id, {
      //                 payableAmount: Number(e.target.value) || 0,
      //               })
      //             }
      //             className="w-full border rounded-xl px-2 py-1 text-xs"
      //           />
      //         </div>

      //         {/* <div>
      //           <label className="text-sm ">Payable status</label>
      //           <select
      //             value={selectedClaim.payableStatus}
      //             onChange={(e) =>
      //               handleUpdateClaim?.(selectedClaim.id, {
      //                 payableStatus: e.target.value,
      //               })
      //             }
      //             className="w-full border rounded-xl px-2 py-1 text-sm  bg-white"
      //           >
      //             <option value="Pending">Pending</option>
      //             <option value="Payment Link Created">
      //               Payment Link Created
      //             </option>
      //             <option value="Paid">Paid</option>
      //             <option value="Not Applicable">Not Applicable</option>
      //           </select>
      //         </div> */}

      //         <div>
      //           <label className="text-sm ">Claim status</label>
      //           <select
      //             value={selectedClaim.status}
      //             onChange={(e) =>
      //               handleUpdateClaim?.(selectedClaim.id, {
      //                 status: e.target.value,
      //               })
      //             }
      //             className="w-full border rounded-xl px-2 py-1 text-sm  bg-white"
      //           >
      //             <option value="Pending">Pending</option>
      //             <option value="In Progress">In Progress</option>
      //             <option value="Approved">Approved</option>
      //             <option value="Rejected">Rejected</option>
      //             <option value="Settled">Settled</option>
      //           </select>
      //         </div>
      //       </div>

      //       {/* Claim Status & Reason */}
      //       <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              

      //         <div className="md:col-span-2">
      //           <label className="text-sm ">
      //             Rejection / internal reason
      //           </label>
      //           <input
      //             type="text"
      //             value={selectedClaim.reason || ""}
      //             onChange={(e) =>
      //               handleUpdateClaim?.(selectedClaim.id, {
      //                 reason: e.target.value,
      //               })
      //             }
      //             className="w-full border rounded-xl px-2 py-1 text-xs"
      //           />
      //         </div>
      //       </div>

      //       {/* Payment Link */}
      //       <div className="grid grid-cols-1 md:grid-cols-[2fr,1fr] gap-3 items-end">
      //         <div>
      //           <label className="text-sm ">Payment link</label>
      //           <div className="flex items-center gap-2">
      //             <input
      //               type="text"
      //               readOnly
      //               value={
      //                 selectedClaim.paymentLink ||
      //                 "No link generated yet"
      //               }
      //               className="flex-1 border rounded-xl px-2 py-1 text-sm  bg-slate-50"
      //             />

      //             <button
      //               type="button"
      //               onClick={() =>
      //                 handleUpdateClaim?.(selectedClaim.id, {
      //                   paymentLink: `https://pay.goex.example/${selectedClaim.id}`,
      //                   payableStatus: "Payment Link Created",
      //                 })
      //               }
      //               className="flex items-center gap-1 text-sm  px-2.5 py-1 rounded-xl border border-blue-200 bg-blue-50 hover:bg-blue-100"
      //             >
      //               <Link2 className="w-3 h-3" />
      //               Create link
      //             </button>
      //           </div>
      //         </div>

      //         <div className="text-sm  text-slate-500">
      //           <p className="mb-1 font-semibold">Flow notes</p>
      //           <p>
      //             Remaining payout collection and follow-ups happen on
      //             retailer / agent dashboards.
      //           </p>
      //         </div>

              
      //       </div>

      //       <BlueButton
      //             onClick={() => setSelectedClaim(null)}
      //             className="flex justify-end text-xs text-slate-500 hover:text-slate-700"
      //           >
      //             Clear Selection
      //           </BlueButton> 
      //     </div>
      //   )}

      //   {showAssignModal && (
      //     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      //       <div className="w-full max-w-md rounded-2xl bg-white p-4 shadow-xl">
      //         <h3 className="text-sm font-semibold text-slate-800 mb-2">
      //           Assign Employee
      //         </h3>

      //         <p className="text-sm  text-slate-500 mb-3">
      //           Claim: <b>{assigningClaim?.raw?.id}</b>
      //         </p>

      //         {loadingEmployees ? (
      //           <RegularLoader />
      //         ) : (
      //           <select
      //             value={selectedEmployee}
      //             onChange={(e) => setSelectedEmployee(e.target.value)}
      //             className="w-full rounded-xl border px-3 py-2 text-sm bg-white"
      //           >
      //             <option value="">Select Employee</option>
      //             {employees.map((emp) => (
      //               <option key={emp.id} value={emp.id}>
      //                 {emp.name}
      //               </option>
      //             ))}
      //           </select>
      //         )}

      //         <div className="mt-4 flex justify-end gap-2">
      //           <button
      //             onClick={() => setShowAssignModal(false)}
      //             className="px-3 py-1.5 text-sm  rounded-xl border border-slate-200 text-slate-600 hover:bg-slate-50"
      //           >
      //             Cancel
      //           </button>

      //           <button
      //             onClick={handleAssignEmployee}
      //             className="px-3 py-1.5 text-sm  rounded-xl bg-blue-600 text-white hover:bg-blue-700"
      //           >
      //             Assign
      //           </button>
      //         </div>
      //       </div>
      //     </div>
      //   )}
      // </SectionCard>
//       )}
//     </div>
//   );
// }


// // import React, { useEffect, useMemo, useState } from "react";
// // import { KpiCard } from "../../../Component/AgentComponents/KpiCard";
// // import { SectionCard } from "../../../Component/AgentComponents/SectionCard";


// // import {
// //   ShieldCheck,
// //   FileText,
// //   IndianRupee,
// //   Edit3,
// //   Link2,
// // } from "lucide-react";
// // import { formatCurrency } from "../../../Component/AdminComponents/formatCurrency";
// // import { Navigate, useLocation, useNavigate } from "react-router-dom";
// // import RegularLoader from "../../../Component/Loader/RegularLoader";
// // import Pagination from "../../../Component/Common/Pagination";
// // import RefreshButton from "../../../Component/Common/RefreshButton";
// // import { BASE_URL, Warrenty_URL } from "../../../config/api";
// // import SimpleTable from "../../../Component/Common/SimpleTable";
// // import Badge from "../../../Component/Common/Badge";
// // import ExpandableCard from "../../../Component/Common/ExpandableCard";


// // const claims = [
// //   {
// //     id: "CLM-5001",
// //     warrantyId: "WAR-1001",
// //     retailer: "Shree Mobile Store",
// //     customer: "Amit Kulkarni",
// //     device: "Samsung A55",
// //     raisedBy: "Retailer", // Retailer | Customer
// //     issue: "Device not powering on",
// //     status: "Pending", // Pending | Approved | Rejected | In Progress | Settled
// //     reason: "",
// //     approvedAmount: 3500,
// //     payableAmount: 3000,
// //     payableStatus: "Pending",
// //     paymentLink: "",
// //     lastUpdated: "2025-10-15",
// //   },
// //   {
// //     id: "CLM-5002",
// //     warrantyId: "WAR-0998",
// //     retailer: "Digital Zone",
// //     customer: "Demo Customer",
// //     device: "mPOS Demo",
// //     raisedBy: "Customer",
// //     issue: "Screen flickering",
// //     status: "Rejected",
// //     reason: "Warranty expired",
// //     approvedAmount: 0,
// //     payableAmount: 0,
// //     payableStatus: "Not Applicable",
// //     paymentLink: "",
// //     lastUpdated: "2025-01-07",
// //   },
// //   {
// //     id: "CLM-5003",
// //     warrantyId: "WAR-1002",
// //     retailer: "A1 Electronics",
// //     customer: "Riya Shah",
// //     device: "Samsung Tab S9",
// //     raisedBy: "Customer",
// //     issue: "No sound from speakers",
// //     status: "Approved",
// //     reason: "",
// //     approvedAmount: 2200,
// //     payableAmount: 2000,
// //     payableStatus: "Paid",
// //     paymentLink: "https://pay.goex.example/CLM-5003",
// //     lastUpdated: "2025-11-10",
// //   },
// // ];


// // const todayISO = () => new Date().toISOString().slice(0, 10);

// // export default function WarrantiesClaimsView({
// // }) {

// //   const [warrantiesData, setWarrantiesData] = useState([]);
// //   const [loadingWarranties, setLoadingWarranties] = useState(true);
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [totalPages, setTotalPages] = useState(1);

// //   const [devices, setDevices] = useState([]);
// //   const [loadingDevices, setLoadingDevices] = useState(true);
// //   const Navigate = useNavigate();

// //   const location = useLocation();

// //   const [claims, setClaims] = useState([]);
// //   const [claimsLoading, setClaimsLoading] = useState(true);
// //   const [claimsPage, setClaimsPage] = useState(1);
// //   const [claimsTotalPages, setClaimsTotalPages] = useState(1);


// //   // ⚡ Coming from KPI → showOnlyActive = true
// //   const showOnlyActive = location.state?.showOnlyActive === true;
// //   const showOnlyOpen = location.state?.showOnlyOpen === true;

// //   const authUserString = localStorage.getItem("authUserData");
// //   const authUser = authUserString ? JSON.parse(authUserString) : null;

// //   const userRole = Number(authUser?.role);
// //   const sessionId = authUser?.id;

 
// //   const fetchWarranties = async () => {
// //     try {
// //       setLoadingWarranties(true);

// //       // let url = `${BASE_URL}get-customers?page=${currentPage}`;
// //       let url = `${BASE_URL}warranty/get-customers?page=${currentPage}`;

// //       // 🔹 ROLE-BASED PARAMS
// //       if (userRole === 2 || userRole === 4) {
// //         // Company / Distributor
// //         url += `&company_id=${sessionId}`;
// //       }

// //       if (userRole === 5) {
// //         // Retailer
// //         url += `&retailer_id=${sessionId}`;
// //       }

// //       // ROLE 1 (Admin) → no extra params

// //       const res = await fetch(url);
// //       const data = await res.json();

// //       if (data?.data) {
// //         setTotalPages(data.last_page || 1);

// //         const transformed = data.data.flatMap((customer) =>
// //           customer.devices.map((device) => ({
// //             custid: customer.id,
// //             RawID: device.id,
// //             id: `WAR-${device.id.toString().padStart(4, "0")}`,
// //             retailer: customer.name,
// //             retailerCode: `RET-${customer.id}`,
// //             customer: customer.name,
// //             deviceType: device.product_name || "Device",
// //             brand: device.brand_name || "Brand",
// //             model: device.model || "-",
// //             imei: device.imei1 || "-",
// //             type: "Sold",
// //             status: device.status || "Active",
// //             soldOn: device.created_at?.slice(0, 10) || "",
// //             expiry: device.expiry_date || "",
// //             plan: device.product_name || "Warranty",
// //             price: device.device_price || 0,
// //           }))
// //         );

// //         setWarrantiesData(transformed);
// //       }
// //     } catch (error) {
// //       console.error("Failed to fetch warranties:", error);
// //     } finally {
// //       setLoadingWarranties(false);
// //     }
// //   };


// //   useEffect(() => {
// //     fetchWarranties();
// //   }, [currentPage]); // <-- IMPORTANT

// //   const buildDevicesUrl = ({ role, id, page }) => {
// //   let url = `${BASE_URL}warranty/get-devices?page=${page}`;

// //   switch (role) {
// //     case 2: // company
// //       url += `&company_id=${id}`;
// //       break;
// //     case 4: // agent
// //       url += `&agent_id=${id}`;
// //       break;
// //     case 5: // retailer
// //       url += `&retailer_id=${id}`;
// //       break;
// //     case 6: // created_by
// //       url += `&created_by=${id}`;
// //       break;
// //     // role 1 (admin) → no extra param
// //     default:
// //       break;
// //   }

// //   return url;
// // };
// //   const fetchDevices = async () => {
// //   try {
// //     setLoadingDevices(true);

// //     const url = buildDevicesUrl({
// //       role: userRole,
// //       id: sessionId,
// //       page: currentPage,
// //     });

// //     const res = await fetch(url);
// //     const json = await res.json();

// //     setDevices(json?.data || []);
// //     setTotalPages(json?.last_page || 1);
// //   } catch (err) {
// //     console.error("Failed to fetch devices", err);
// //     setDevices([]);
// //   } finally {
// //     setLoadingDevices(false);
// //   }
// // };

// // useEffect(() => {
// //   fetchDevices();
// // }, [currentPage, userRole, sessionId]);


// //   const deviceRows = useMemo(() => {
// //   return devices.map((d) => ({
// //     raw: d,
// //     cells: [
// //       {
// //         title: (d.w_code),
// //         sub: `Sold: ${d.created_at?.slice(0, 10)}`,
// //         extra: `Exp: ${d.expiry_date}`,
// //       },
// //       {
// //         title: d.customer?.retailer?.business_name || "—",
// //         sub: d.customer?.name || "—",
// //       },
// //       {
// //         title: `${d.product_name || "Device"} · ${d.brand_name}`,
// //         sub: `Model: ${d.model || "-"}`,
// //         extra: `IMEI: ${d.imei1 || d.serial || "-"}`,
// //       },
// //       d.product_name || "Warranty",
// //       <Badge
// //         label={d.available_claim > 0 ? "Active" : "Expired"}
// //         color={d.available_claim > 0 ? "green" : "red"}
// //       />,
// //     ],
// //   }));
// // }, [devices]);

// //   const fetchClaims = async () => {
// //   try {
// //     setClaimsLoading(true);

// //     let url = `${BASE_URL}warranty/claims/list?page=${claimsPage}`;

// //     if (userRole === 2) {
// //       url += `&company_id=${sessionId}`;
// //     }

// //     const res = await fetch(url);
// //     const json = await res.json();

// //     if (json?.status) {
// //       setClaims(json.data?.data || []);
// //       setClaimsTotalPages(json.data?.last_page || 1);
// //     } else {
// //       setClaims([]);
// //     }
// //   } catch (err) {
// //     console.error("Failed to fetch claims", err);
// //     setClaims([]);
// //   } finally {
// //     setClaimsLoading(false);
// //   }
// // };

// //   useEffect(() => {
// //   fetchClaims();
// // }, [claimsPage, userRole, sessionId]);

// //   const normalizedClaims = useMemo(() => {
// //   return claims.map((c) => ({
// //     id: `CLM-${c.id}`,
// //     warrantyId: `WAR-${c.w_device_id}`,
// //     retailer:
// //       c.drop_retailer?.business_name ||
// //       c.customer?.name ||
// //       "—",
// //     customer: c.customer?.name || "—",
// //     device: `${c.device?.product_name || ""} ${c.device?.model || ""}`,
// //     raisedBy: c.claim_type === "pickup" ? "Customer" : "Retailer",
// //     issue: c.issue_description,
// //     status:
// //       c.status === "otp_sent"
// //         ? "Pending"
// //         : c.status.replace("_", " "),
// //     reason: "",
// //     approvedAmount: c.estimate_amount || 0,
// //     payableAmount: c.estimate_amount || 0,
// //     payableStatus: "Pending",
// //     paymentLink: "",
// //     lastUpdated: c.updated_at?.slice(0, 10),
// //   }));
// // }, [claims]);

// //   const claimRows = useMemo(() => {
// //     return normalizedClaims.map((c) => ({
// //       raw: c,
// //       cells: [
// //         {
// //           title: c.id,
// //           sub: `Warranty: ${c.warrantyId}`,
// //         },
// //         {
// //           title: c.retailer,
// //           sub: c.customer,
// //         },
// //         {
// //           title: c.device,
// //           sub: c.issue,
// //         },
// //         {
// //           title: `₹ ${formatCurrency(c.approvedAmount)}`,
// //           sub: `Payable: ₹ ${formatCurrency(c.payableAmount)}`,
// //         },
// //         <Badge
// //           label={c.status}
// //           color={
// //             c.status === "Approved"
// //               ? "green"
// //               : c.status === "Rejected"
// //               ? "red"
// //               : "yellow"
// //           }
// //         />,
// //       ],
// //     }));
// //   }, [normalizedClaims]);

// //   const claimCards = useMemo(() => {
// //   return normalizedClaims.map((c) => (
// //     <ExpandableCard
// //       key={c.id}
// //       title={c.id}
// //       badge={{
// //         label: c.status,
// //         color:
// //           c.status === "Approved"
// //             ? "green"
// //             : c.status === "Rejected"
// //             ? "red"
// //             : "yellow",
// //       }}
// //       primaryFields={[
// //         { label: "Customer", value: c.customer },
// //         { label: "Device", value: c.device },
// //         { label: "Issue", value: c.issue },
// //       ]}
// //       extraFields={[
// //         { label: "Warranty", value: c.warrantyId },
// //         { label: "Approved", value: `₹ ${formatCurrency(c.approvedAmount)}` },
// //         { label: "Payable", value: `₹ ${formatCurrency(c.payableAmount)}` },
// //       ]}
// //       onView={() => setSelectedClaimId(c.id)}
// //     />
// //   ));
// // }, [normalizedClaims]);


// //   const onPageChange = (page) => {
// //     if (page >= 1 && page <= totalPages) {
// //       setCurrentPage(page);
// //     }
// //   };

// //   // ⚡ Filter logic
// //   const filteredWarranties = showOnlyActive
// //     ? warrantiesData.filter((w) => w.status === "Active")
// //     : warrantiesData;

// //   const filteredClaims = showOnlyOpen
// //     ? claims.filter((w) => w.status === "Pending")
// //     : claims;


// //   const [claimList, setClaimList] = useState(claims);
// //   const [selectedClaimId, setSelectedClaimId] = useState(null);
// //   const totalApproved = claims.reduce(
// //     (sum, c) => sum + (c.approvedAmount || 0),
// //     0
// //   );
// //   const totalPayable = claims.reduce(
// //     (sum, c) => sum + (c.payableAmount || 0),
// //     0
// //   );

// //   const selectedClaim =
// //     claims.find((c) => c.id === selectedClaimId) || null;

// //   const handleClaimAction = (id, action) => {
// //     setClaimList((prev) =>
// //       prev.map((c) => {
// //         if (c.id !== id) return c;
// //         if (action === "approve") {
// //           return {
// //             ...c,
// //             status: "Approved",
// //             payableStatus: c.payableStatus === "Not Applicable" ? "Pending" : c.payableStatus,
// //             lastUpdated: todayISO(),
// //           };
// //         }
// //         if (action === "reject") {
// //           return {
// //             ...c,
// //             status: "Rejected",
// //             payableStatus: "Not Applicable",
// //             reason: c.reason || "Rejected by admin",
// //             lastUpdated: todayISO(),
// //           };
// //         }
// //         return c;
// //       })
// //     );
// //   };

// //   const handleUpdateClaim = (id, updates) => {
// //     setClaimList((prev) =>
// //       prev.map((c) => (c.id === id ? { ...c, ...updates, lastUpdated: todayISO() } : c))
// //     );
// //   };

// //   return (
// //     <div className="space-y-4">

// //       {/* KPI Cards */}
// //       <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
// //         <KpiCard
// //           label="Total Warranties"
// //           value={warrantiesData.length}
// //           subLabel={`Active: ${
// //             warrantiesData.filter((w) => w.status === "Active").length
// //           }`}
// //           icon={ShieldCheck}
// //         />

// //         <KpiCard
// //           label="Claims Raised"
// //           value={claims.length}
// //           subLabel={`Open: ${
// //             claims.filter(
// //               (c) =>
// //                 c.status === "Pending" ||
// //                 c.status === "In Progress" ||
// //                 c.status === "Approved"
// //             ).length
// //           }`}
// //           icon={FileText}
// //         />

// //         <KpiCard
// //           label="Approved Amount"
// //           value={`₹ ${formatCurrency(totalApproved)}`}
// //           subLabel="All claims"
// //           icon={IndianRupee}
// //         />

// //         <KpiCard
// //           label="Payable Amount"
// //           value={`₹ ${formatCurrency(totalPayable)}`}
// //           subLabel="To be paid / paid"
// //           icon={IndianRupee}
// //         />
// //       </div>

// //       {/* Warranty Registry */}
// //       {!showOnlyOpen && (
// //         <SectionCard title="Warranty Registry (Retailer + Customer)">
// //           <div className="flex justify-end">
// //             <RefreshButton onClick={fetchDevices} />
// //           </div>

// //           {loadingDevices ? (
// //             <RegularLoader />
// //           ) : (
// //             <SimpleTable
// //               headers={[
// //                 "Warranty",
// //                 "Retailer / Customer",
// //                 "Device",
// //                 "Plan",
// //                 "Status",
// //               ]}
// //               rows={deviceRows}
// //               currentPage={currentPage}
// //               totalPages={totalPages}
// //               onPageChange={setCurrentPage}
// //               showSrNo
// //               renderActions={(row) => (
// //                 <button
// //                   onClick={(e) => {
// //                     e.stopPropagation(); // prevent row click
// //                     Navigate(`/warranty-details/${row.w_customer_id}`);
// //                   }}
// //                   className="px-3 py-1 text-sm  bg-blue-600 text-white rounded-md hover:bg-blue-700"
// //                 >
// //                   View
// //                 </button>
// //               )}
// //             />

// //           )}
// //         </SectionCard>

// //       )}


// //       {/* Claims Table */}
// //       {!showOnlyActive && (
// //       <SectionCard title="Claims – Approvals, Rejections & Reasons">

// //         <div className="flex justify-end">
// //             <RefreshButton onClick={fetchClaims} />
// //           </div>
// //         {claimsLoading ? (
// //           <RegularLoader />
// //         ) : (
// //           <>
// //             {/* DESKTOP */}
// //             <div className="hidden md:block">
// //               <SimpleTable
// //                 headers={[
// //                   "Claim",
// //                   "Retailer / Customer",
// //                   "Issue",
// //                   "Amounts",
// //                   "Status",
// //                   // "Admin Action",   // ✅ NEW COLUMN
// //                 ]}
// //                 rows={claimRows}
// //                 currentPage={claimsPage}
// //                 totalPages={claimsTotalPages}
// //                 onPageChange={setClaimsPage}
// //                 showSrNo
// //                 renderActions={(c) => (
// //                   <div className="flex flex-wrap justify-center gap-1">
// //                     <button
// //                       onClick={(e) => {
// //                         e.stopPropagation();
// //                         handleClaimAction(c.id, "approve");
// //                       }}
// //                       disabled={c.status === "Approved" || c.status === "Settled"}
// //                       className="text-[10px] px-2 py-0.5 rounded-lg border border-emerald-200 text-emerald-700 bg-emerald-50 hover:bg-emerald-100 disabled:opacity-50"
// //                     >
// //                       Approve
// //                     </button>

// //                     <button
// //                       onClick={(e) => {
// //                         e.stopPropagation();
// //                         handleClaimAction(c.id, "reject");
// //                       }}
// //                       disabled={c.status === "Rejected"}
// //                       className="text-[10px] px-2 py-0.5 rounded-lg border border-rose-200 text-rose-700 bg-rose-50 hover:bg-rose-100 disabled:opacity-50"
// //                     >
// //                       Reject
// //                     </button>
// //                   </div>
// //                 )}
// //               />
// //             </div>

// //             {/* MOBILE */}
// //             <div className="md:hidden space-y-2">
// //               {claimCards}
// //             </div>
// //           </>
// //         )}
// //       </SectionCard>

// //       )}

// //       {/* Claim Console */}
// //       <SectionCard
// //         title="Claim Handling Console"
// //         right={
// //           <span className="text-sm  text-slate-400 flex items-center gap-1">
// //             <FileText className="w-3 h-3" />
// //             Admin-only
// //           </span>
// //         }
// //       >
// //         {!claims.length ? (
// //           <p className="text-sm  text-slate-500">No claims available.</p>
// //         ) : !selectedClaim ? (
// //           <p className="text-sm  text-slate-500">
// //             Select a claim above to update approved amount, payable
// //             amount, payment link and statuses.
// //           </p>
// //         ) : (
// //           <div className="text-sm  space-y-3">

// //             {/* Summary */}
// //             <div className="flex flex-wrap justify-between gap-2">
// //               <div>
// //                 <p className="text-sm  text-slate-500">Claim</p>
// //                 <p className="text-sm font-semibold">
// //                   {selectedClaim.id} · {selectedClaim.device}
// //                 </p>
// //                 <p className="text-sm  text-slate-500">
// //                   {selectedClaim.retailer} · {selectedClaim.customer}
// //                 </p>
// //               </div>

// //               <div className="flex flex-col items-end text-sm  text-slate-500">
// //                 <span>Last updated: {selectedClaim.lastUpdated}</span>
// //                 <span>Raised by: {selectedClaim.raisedBy}</span>
// //               </div>
// //             </div>

// //             {/* Editable Fields */}
// //             <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
// //               <div>
// //                 <label className="text-sm ">Approved amount (₹)</label>
// //                 <input
// //                   type="number"
// //                   value={selectedClaim.approvedAmount ?? ""}
// //                   onChange={(e) =>
// //                     handleUpdateClaim?.(selectedClaim.id, {
// //                       approvedAmount: Number(e.target.value) || 0,
// //                     })
// //                   }
// //                   className="w-full border rounded-xl px-2 py-1 text-xs"
// //                 />
// //               </div>

// //               <div>
// //                 <label className="text-sm ">Payable amount (₹)</label>
// //                 <input
// //                   type="number"
// //                   value={selectedClaim.payableAmount ?? ""}
// //                   onChange={(e) =>
// //                     handleUpdateClaim?.(selectedClaim.id, {
// //                       payableAmount: Number(e.target.value) || 0,
// //                     })
// //                   }
// //                   className="w-full border rounded-xl px-2 py-1 text-xs"
// //                 />
// //               </div>

// //               <div>
// //                 <label className="text-sm ">Payable status</label>
// //                 <select
// //                   value={selectedClaim.payableStatus}
// //                   onChange={(e) =>
// //                     handleUpdateClaim?.(selectedClaim.id, {
// //                       payableStatus: e.target.value,
// //                     })
// //                   }
// //                   className="w-full border rounded-xl px-2 py-1 text-sm  bg-white"
// //                 >
// //                   <option value="Pending">Pending</option>
// //                   <option value="Payment Link Created">
// //                     Payment Link Created
// //                   </option>
// //                   <option value="Paid">Paid</option>
// //                   <option value="Not Applicable">Not Applicable</option>
// //                 </select>
// //               </div>
// //             </div>

// //             {/* Claim Status & Reason */}
// //             <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
// //               <div>
// //                 <label className="text-sm ">Claim status</label>
// //                 <select
// //                   value={selectedClaim.status}
// //                   onChange={(e) =>
// //                     handleUpdateClaim?.(selectedClaim.id, {
// //                       status: e.target.value,
// //                     })
// //                   }
// //                   className="w-full border rounded-xl px-2 py-1 text-sm  bg-white"
// //                 >
// //                   <option value="Pending">Pending</option>
// //                   <option value="In Progress">In Progress</option>
// //                   <option value="Approved">Approved</option>
// //                   <option value="Rejected">Rejected</option>
// //                   <option value="Settled">Settled</option>
// //                 </select>
// //               </div>

// //               <div className="md:col-span-2">
// //                 <label className="text-sm ">
// //                   Rejection / internal reason
// //                 </label>
// //                 <input
// //                   type="text"
// //                   value={selectedClaim.reason || ""}
// //                   onChange={(e) =>
// //                     handleUpdateClaim?.(selectedClaim.id, {
// //                       reason: e.target.value,
// //                     })
// //                   }
// //                   className="w-full border rounded-xl px-2 py-1 text-xs"
// //                 />
// //               </div>
// //             </div>

// //             {/* Payment Link */}
// //             <div className="grid grid-cols-1 md:grid-cols-[2fr,1fr] gap-3 items-end">
// //               <div>
// //                 <label className="text-sm ">Payment link</label>
// //                 <div className="flex items-center gap-2">
// //                   <input
// //                     type="text"
// //                     readOnly
// //                     value={
// //                       selectedClaim.paymentLink ||
// //                       "No link generated yet"
// //                     }
// //                     className="flex-1 border rounded-xl px-2 py-1 text-sm  bg-slate-50"
// //                   />

// //                   <button
// //                     type="button"
// //                     onClick={() =>
// //                       handleUpdateClaim?.(selectedClaim.id, {
// //                         paymentLink: `https://pay.goex.example/${selectedClaim.id}`,
// //                         payableStatus: "Payment Link Created",
// //                       })
// //                     }
// //                     className="flex items-center gap-1 text-sm  px-2.5 py-1 rounded-xl border border-blue-200 bg-blue-50 hover:bg-blue-100"
// //                   >
// //                     <Link2 className="w-3 h-3" />
// //                     Create link
// //                   </button>
// //                 </div>
// //               </div>

// //               <div className="text-sm  text-slate-500">
// //                 <p className="mb-1 font-semibold">Flow notes</p>
// //                 <p>
// //                   Remaining payout collection and follow-ups happen on
// //                   retailer / agent dashboards.
// //                 </p>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </SectionCard>
// //     </div>
// //   );
// // }
